import { useState } from "react";
import api from "../utils/api";
import { toast } from "react-toastify";

export const useAllocation = (restaurantId) => {
  const handleSubmitAllocation = async (allocation) => {
    try {
      const payload = {
        ...allocation,
        restaurantId,
      };

      const res = await api.post("/allocation/create", payload);
      toast.success("Customer allocated successfully!");

      const newCustomer = {
        id: res.data._id,
        name: res.data.name,
        phone: res.data.phone,
        tableNumber: res.data.tableNumber,
        customerCount: res.data.customerCount,
      };

      return newCustomer;
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to allocate table");
      return null;
    }
  };

  const handleCancelAllocation = async (allocationId) => {
    try {
      await api.post(`/allocation/cancel/${allocationId}`, {
        restaurantId,
      });
      toast.success("Allocation cancelled");
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to cancel allocation");
      throw err;
    }
  };

  return {
    handleSubmitAllocation,
    handleCancelAllocation,
  };
};
